import { useState, useEffect } from "react";
import AppHeader from "./../../../components/common/appHeader/AppHeader";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { useRecommendHall } from "./../../../utils/hooks/useRecommendHall";
import NotiBox from "../../../components/common/notiBox/notiBox";
import Blank from "../../../components/common/blank/Blank";
import LinkWegazine from "../../../components/common/linkWegazine/LinkWegazine";
import { setExpectedPerson } from "@src/@slice/recommendHallSlice";
import NotificationArccodion from "@src/components/booking/realtimeBooking/notification/NotificationArccodion";

const visitorItems = ["~150", "150~200", "200~250", "250~300", "300~"];
const Visitor = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const { hallData, dispatch } = useRecommendHall();
  useEffect(() => {
    const expectedPerson = hallData.expectedPerson;
    setValidate(expectedPerson.min !== null || expectedPerson.max !== null);
  }, [hallData.expectedPerson]);
  useEffect(() => {
    if (
      hallData.hallStyleTypes.length === 0 ||
      hallData.weddingType === "" ||
      hallData.weddingRegions.length === 0
    ) {
      navigate("/recommend/hall/start", { replace: true });
    }
  }, []);
  const goNext = () => {
    navigate("/recommend/hall/meal-type");
  };
  return (
    <div>
      <AppHeader type="stack" actionItems={[{ name: "close" }]} />
      <div className="layout-fix-button with-app-header">
        <div>
          <PageTitle
            title={`예상 보증인원을 선택해주세요.`}
            type=""
          />
          <div className="common-wrap">
            <div style={{ height: 20 }} />
            <ul className="selectable-list-wrap items-2 font-size-up">
              {visitorItems.map((item) => {
                const splitVal = item.split("~");
                const val0 = splitVal[0];
                const val1 = splitVal[1];
                const min = hallData.expectedPerson.min ? hallData.expectedPerson.min : "";
                const max = hallData.expectedPerson.max ? hallData.expectedPerson.max : "";
                return (
                  <li key={`visitor-item-${item}`}>
                    <div
                      className={`${val0}~${val1}` === `${min}~${max}` ? "selected" : ""}
                      onClick={() =>
                        dispatch(
                          setExpectedPerson({
                            min: val0 ? +val0 : null,
                            max: val1 ? +val1 : null,
                          }),
                        )
                      }
                    >
                      {val0 && val1 && (
                        <>
                          {val0 ? `${val0}명` : ""} ~ {val1 ? `${val1}명` : ""}
                        </>
                      )}
                      {val0 === "" && <>{val1}명 미만</>}
                      {val1 === "" && <>{val0}명 이상</>}
                    </div>
                  </li>
                );
              })}
            </ul>
            <NotificationArccodion className='recommend-hall-noti' isOpen={true} title={"예상 보증인원 설정 시 참고해 주세요."} useArccodion={false}>
              <div>
                <p>보증인원 조건은 예식 날짜와 시간대에 따라 달라집니다. 아래의 일정 별 추천 보증인원을 참고해 선택해보세요.</p>
                <ul>
                  <li>주말 점심 예식 : 250명 이상</li>
                  <li>주말 오전 혹은 오후 예식 : 200명~250명</li>
                  <li>주말 오후 및 저녁 예식 : 150명~200명</li>
                  <li>소규모 예식 : 150명 미만</li>
                </ul>
                <p>(실제 보증인원 조건은 웨딩홀마다 상이합니다.)</p>
              </div>
            </NotificationArccodion>
          </div>
        </div>
        <div>
          {/* <LinkWegazine
            title="하객 인원수에 대해 잘 모르겠다면?"
            link="https://www.weddingbook.com/wegazine/116419fe-6dfc-11ec-b0a5-0aea5320e7f2?wbTitle=%20"
          /> */}
          <Blank height={20} />
          <div className="btn-wrap">
            <button
              onClick={goNext}
              className={`btn btn-giant btn-red500 btn-full ${!validate ? "btn-disabled" : ""}`}
              disabled={!validate}
            >
              다음
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Visitor;
